import React from "react";

const EmptyState = () => {
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center">
      <div className="w-[320px] h-[252px]">
        <img
          className="w-full h-full"
          src="https://cufront-assets.s3.amazonaws.com/images/empty-state.png"
          alt=".."
        />
      </div>
      <div className="mt-5 text-center">
        <div className="text-[32px] helvetica">Coming soon.</div>
        <div className="text-xl helvetica text-[#999999]">Stay Connected!</div>
      </div>
    </div>
  );
};

export default EmptyState;
